module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow-1992b393589014313e474639ec69eeb2.png";